import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';

export const fetchChallengeGroupsRequest = createAction('fetchChallengeGroupsRequest');
export const fetchChallengeGroupsSuccess = createAction<ChallengeGroup[]>(
    'fetchChallengeGroupsSuccess',
);
export const fetchChallengeGroupsFailure = createAction('fetchChallengeGroupsFailure');

export const fetchChallengeGroups = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchChallengeGroupsRequest());
    try {
        const { data } = await api.get<ChallengeGroup[]>('admin/challengeGroups');

        dispatch(fetchChallengeGroupsSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengeGroupsFailure, e);
    }
};
